import './Home.css';
import '../../App.css';
import React from 'react';
import { ReactComponent as ClientManagementIcon } from '../../assets/icons/ClientManagementIcon.svg';
import { ReactComponent as ComprehensiveAnalytics } from '../../assets/icons/ComperhensiveAnalytics.svg';
import { ReactComponent as TaskAutomation } from '../../assets/icons/TaskAutomation.svg';
import logo from '../../assets/images/logo.jpg';
import {strings} from '../../localization/Localization';

const Home = () => {
  return (
    <div className='container'>
      <div className='d-flex justify-content-center mt-3'>
        <img src={logo} alt="logo" />
      </div>
      <div className='text-center mt-5'>
        <h1>{strings.welcomeNote}</h1>
        <p className='mt-3'>{strings.slogan}</p>
      </div>
      <div className='mt-5 p-4 section-highlight'>
        <h2 className='text-center'>{strings.whatWeDeliver}</h2>
        <div className='row mt-4'>
          <div className='col-md-4 text-center'>
            <ClientManagementIcon width='50px' height='50px'/>
            <h4>{strings.efficientClientManagement}</h4>
            <p>{strings.efficientClientManagementSlogan}</p>
          </div>
          <div className='col-md-4 text-center'>
            <ComprehensiveAnalytics width='50px' height='50px'/>
            <h4>{strings.comprehensiveAnalytics}</h4>
            <p>{strings.comprehensiveAnalyticsSlogan}</p>
          </div>
          <div className='col-md-4 text-center'>
            <TaskAutomation width='50px' height='50px'/>
            <h4>{strings.taskAutomation}</h4>
            <p>{strings.taskAutomationSlogan}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
